import React, { useState, useEffect } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  Label,
  Input,
  FormFeedback,
  CardTitle,
} from "reactstrap"
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"
import withRouter from "components/Common/withRouter"
import Breadcrumb from "../../components/Common/Breadcrumb"
import { getuserinfo, updateprofilereq } from "helpers/requests"
import { editProfile, resetProfileFlag } from "../../store/actions"
import image from '../../assets/images/users/avatar.jpeg'

const UserProfile = () => {
  const userId = localStorage.getItem("userId")
  const [user, setUser] = useState({
    username: "JohnDoe",
    email: "johndoe@example.com",
    age: 30,
    facebookUrl: "https://facebook.com/johndoe",
    instagramUrl: "https://instagram.com/johndoe",
    twitterUrl: "https://twitter.com/johndoe",
    wilaya: "Algiers",
    role: "ADMIN",
  })
  const dispatch = useDispatch()
  const [id, setId] = useState("")
  const [email, setEmail] = useState(user.email)
  const [name, setName] = useState(user.username)
  const [age, setAge] = useState(user.age)
  const [facebookUrl, setFacebookUrl] = useState(user.facebookUrl)
  const [instagramUrl, setInstagramUrl] = useState(user.instagramUrl)
  const [role, setRole] = useState(user.role)
  const [twitterUrl, setTwitterUrl] = useState(user.twitterUrl)
  const [wilaya, setWilaya] = useState(user.wilaya)
  const [username, setUsername] = useState(user.username)

  const ProfileProperties = createSelector(
    (state) => state.Profile,
    (profile) => ({
      error: profile.error,
      success: profile.success,
    })
  )
  const { error, success } = useSelector(ProfileProperties)

  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      const authUser = JSON.parse(localStorage.getItem("authUser"))
      setUser(authUser) // Update user state with authUser
      dispatch(resetProfileFlag())
    }
  }, [dispatch])

  useEffect(() => {
    const getUser = async () => {
      try {
        const userData = await getuserinfo(userId)
        const {
          id,
          username,
          email,
          age,
          facebookUrl,
          instagramUrl,
          role,
          twitterUrl,
          wilaya,
        } = userData
        setAge(age || 30)
        setFacebookUrl(facebookUrl || "https://facebook.com")
        setInstagramUrl(instagramUrl || "https://instagram.com")
        setRole(role || "ADMIN")
        setTwitterUrl(twitterUrl || "https://twitter.com")
        setWilaya(wilaya || "Algiers")
        setId(id)
        setName(username || "JohnDoe")
        setEmail(email || "johndoe@example.com")
      } catch (err) {
        console.error("Error fetching user data:", err)
        // Handle error, e.g., set a state for error message
      }
    }
    if (userId) {
      getUser()
    }
  }, [userId]) // Fetch data when userId changes

  const handleSubmit = async () => {
    try {
      const updatedProfile = {
        username: name,
        email,
        age,
        facebookUrl,
        instagramUrl,
        role,
        twitterUrl,
        wilaya,
      }

      if (id) {
        const res = await updateprofilereq(
          updatedProfile,
          "8fa1d7fb-a7e8-43da-8268-ba1f52a44f10"
        )
       
      } else {
        console.error("User ID is undefined")
      }
    } catch (err) {
      console.log("")
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Skote" breadcrumbItem="Profile" />
          <Row>
            <Col lg="12">
              {error ? <Alert color="danger">{error}</Alert> : null}
              {success ? <Alert color="success">{success}</Alert> : null}

              <Card>
              <CardBody>
    <div className="d-flex">
      <div className="ms-3">
        <img
          src={image}  // Replace with the actual path to your image
          alt="Profile Image"
          className="rounded-circle avatar-sm"
        />
      </div>
      <div className="flex-grow-1 align-self-center ms-4">
        <div className="text-muted">
          <h5>{name}</h5>
          <p className="mb-1">{email}</p>
        </div>
      </div>
    </div>
  </CardBody>
              </Card>
            </Col>
          </Row>
          <h4 className="card-title mb-4">Additional data</h4>

          <Row>
            <Col xl={12}>
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">Additional data</CardTitle>
                  <Row className="mb-4">
                    <Label className="col-sm-3 col-form-label">Username</Label>
                    <Col sm={9}>
                      <Input
                        type="text"
                        className="form-control"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        disabled
                      />
                    </Col>
                  </Row>
                  <Row className="mb-4">
                    <Label className="col-sm-3 col-form-label">Email</Label>
                    <Col sm={9}>
                      <Input
                        type="email"
                        className="form-control"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        disabled
                      />
                    </Col>
                  </Row>
                  {/* Add new fields here */}
                  <Row className="mb-4">
                    <Label className="col-sm-3 col-form-label">Age</Label>
                    <Col sm={9}>
                      <Input
                        type="number"
                        className="form-control"
                        value={age}
                        onChange={(e) => setAge(e.target.value)}
                      />
                    </Col>
                  </Row>
                  <Row className="mb-4">
                    <Label className="col-sm-3 col-form-label">Facebook URL</Label>
                    <Col sm={9}>
                      <Input
                        type="text"
                        className="form-control"
                        value={facebookUrl}
                        onChange={(e) => setFacebookUrl(e.target.value)}
                      />
                    </Col>
                  </Row>
                  <Row className="mb-4">
                    <Label className="col-sm-3 col-form-label">Instagram URL</Label>
                    <Col sm={9}>
                      <Input
                        type="text"
                        className="form-control"
                        value={instagramUrl}
                        onChange={(e) => setInstagramUrl(e.target.value)}
                      />
                    </Col>
                  </Row>
                  <Row className="mb-4">
                    <Label className="col-sm-3 col-form-label">Twitter URL</Label>
                    <Col sm={9}>
                      <Input
                        type="text"
                        className="form-control"
                        value={twitterUrl}
                        onChange={(e) => setTwitterUrl(e.target.value)}
                      />
                    </Col>
                  </Row>
                  <Row className="mb-4">
                    <Label className="col-sm-3 col-form-label">Wilaya</Label>
                    <Col sm={9}>
                      <Input
                        type="text"
                        className="form-control"
                        value={wilaya}
                        onChange={(e) => setWilaya(e.target.value)}
                      />
                    </Col>
                  </Row>
                  <Row className="mb-4">
                    <Label className="col-sm-3 col-form-label">Role</Label>
                    <Col sm={9}>
                      <Input
                        type="select"
                        className="form-control"
                        value={role}
                        onChange={(e) => setRole(e.target.value)}
                      >
                        <option value="ADMIN">ADMIN</option>
                        <option value="CO_ADMIN">CO_ADMIN</option>
                        <option value="CONSULTEER">CONSULTEER</option>
                      </Input>
                    </Col>
                  </Row>
                  <Row className="justify-content-end">
                    <Col sm={9}>
                      <div>
                        {error ? (
                          <FormFeedback type="invalid">{error}</FormFeedback>
                        ) : null}
                      </div>
                      <div>
                        <Button onClick={handleSubmit} color="primary" className="w-md">
                          Submit
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(UserProfile)
